import { createReducer, on, Action } from '@ngrx/store';

import * as StatsigExperimentActions from '@statsig/store/statsig.actions';
import { StatsigExperimentsConfig } from '@statsig/statsig.entities';

export const statsigExperimentsKey = 'statsigExperiments';

export const initialStatsigExperimentsState = [];

const statsigExperimentReducer = createReducer(
  initialStatsigExperimentsState,
  on(StatsigExperimentActions.fetchStatsigExperimentsSuccess, (state, { experiments }) => experiments)
);

export const statsigReducer = (state: StatsigExperimentsConfig[], action: Action): StatsigExperimentsConfig[] => {
  return statsigExperimentReducer(state, action);
};
